import { MapLayouts } from "./map-layout.enum";
import { Factions } from "./faction.enum";

/**
 * For factions: <br>
 * 0: West/North
 * 1: East/South
 */

export const mapProperties = {
    ct: {
        layout: MapLayouts.HORIZONTAL,
        factions: {
            0: Factions.ALLIES,
            1: Factions.AXIS
        }
    },
    driel: {
        layout: MapLayouts.VERTICAL,
        factions: {
            0: Factions.AXIS,
            1: Factions.ALLIES
        }
    },
    elalamein: {
        layout: MapLayouts.HORIZONTAL,
        factions: {
            0: Factions.AXIS,
            1: Factions.ALLIES
        }
    },
    elsenborn: {
        layout: MapLayouts.VERTICAL,
        factions: {
            0: Factions.ALLIES,
            1: Factions.AXIS
        }
    },
    foy: {
        layout: MapLayouts.VERTICAL,
        factions: {
            0: Factions.AXIS,
            1: Factions.ALLIES
        }
    },
    hill400: {
        layout: MapLayouts.HORIZONTAL,
        factions: {
            0: Factions.ALLIES,
            1: Factions.AXIS
        }
    },
    hurtgen: {
        layout: MapLayouts.HORIZONTAL,
        factions: {
            0: Factions.ALLIES,
            1: Factions.AXIS
        }
    },
    kharkov: {
        layout: MapLayouts.VERTICAL,
        factions: {
            0: Factions.ALLIES,
            1: Factions.AXIS
        }
    },
    kursk: {
        layout: MapLayouts.VERTICAL,
        factions: {
            0: Factions.ALLIES,
            1: Factions.AXIS
        }
    },
    mortain: {
        layout: MapLayouts.HORIZONTAL,
        factions: {
            0: Factions.ALLIES,
            1: Factions.AXIS
        }
    },
    omaha: {
        layout: MapLayouts.HORIZONTAL,
        factions: {
            0: Factions.AXIS,
            1: Factions.ALLIES
        }
    },
    phl: {
        layout: MapLayouts.VERTICAL,
        factions: {
            0: Factions.ALLIES,
            1: Factions.AXIS
        }
    },
    remagen: {
        layout: MapLayouts.VERTICAL,
        factions: {
            0: Factions.AXIS,
            1: Factions.ALLIES
        }
    },
    sme: {
        layout: MapLayouts.HORIZONTAL,
        factions: {
            0: Factions.AXIS,
            1: Factions.ALLIES
        }
    },
    stalin: {
        layout: MapLayouts.HORIZONTAL,
        factions: {
            0: Factions.AXIS,
            1: Factions.ALLIES
        }
    },
    stmarie: {
        layout: MapLayouts.VERTICAL,
        factions: {
            0: Factions.AXIS,
            1: Factions.ALLIES
        }
    },
    utah: {
        layout: MapLayouts.HORIZONTAL,
        factions: {
            0: Factions.AXIS,
            1: Factions.ALLIES
        }
    },
};